import { TotpImageClass } from '../../components/descope-totp-image/TotpImageClass';

const vars = TotpImageClass.cssVarList;

const logo = {
  [vars.fallbackUrl]: 'url(https://imgs.descope.com/components/totp-placeholder.svg)',
};

export default logo;
export { vars };
